import { Ref, computed, ComputedRef } from '@vue/composition-api';
import { keyEnumObject, ValueTypeOf } from '@berlin-front/common/utils';

/**
 * progressを元に計算した値を返す
 * @param progress 進捗度合。0~1の少数。
 * @returns {
 *  progressTimes100 progressに100をかけた値
 *  progressRounded progressTimes100を整数に四捨五入した値
 * }
 */
export const useComputedProgress = (progress: Ref<number>) => {
  const progressTimes100 = computed(() => progress.value * 100);
  const progressRounded = computed(() => Math.round(progressTimes100.value));

  return {
    progressTimes100,
    progressRounded,
  };
};

/**
 * 高さサイズの種別。
 */
export const HEIGHT_MAP = {
  small: 6,
  middle: 10,
} as const;

/**
 * 高さサイズ種別定数。
 */
export const HEIGHT_TYPE = keyEnumObject(HEIGHT_MAP);

/**
 * 高さサイズ種別の型。
 */
export type HeightType = ValueTypeOf<typeof HEIGHT_TYPE>;

/**
 * 高さサイズごとに設定されてる高さ（px）を返す
 * @param heightSize 高さサイズ。small｜middle
 * @returns height 6｜10
 */
export const useHeight = (heightSize: Ref<HeightType>): ComputedRef<number> => {
  const height = computed(() => HEIGHT_MAP[heightSize.value]);
  return height;
};
